import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { chainIdToImage, chainIdToName } from '@constants/networks';
import { UserApiService } from '@http/user-api.service';
import { Currency } from '@interfaces/currency.interface';
import { AuthService } from '@services/auth.service';
import { CurrencyService } from '@services/currency.service';
import { WalletWeb3Service } from '@services/web3modal.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { filter, Observable, Subject, take, takeUntil } from 'rxjs';
import { ReferalModalComponent } from 'src/app/modals/referal-modal/referal-modal.component';

@Component({
  selector: 'cd-header-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class HeaderNavbarComponent implements OnDestroy {
  chainIdToImage = chainIdToImage;
  chainIdToName = chainIdToName;

  isHome = false;

  currencies;
  currentCurrency$;
  private destroyed$ = new Subject<void>();

  userAvatar$: Observable<any>;

  currencyDropdown: any;

  constructor(
    private router: Router,
    public auth: AuthService,
    private currencyService: CurrencyService,
    private userService: UserApiService,
    public walletService: WalletWeb3Service,
    private modalService: BsModalService
  ) {    
    this.currencies = this.currencyService.getCurrencies();
    this.currentCurrency$  = this.currencyService.currentCurrency$;
    this.userAvatar$ = this.userService.cachedUserAvatar$;

    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        this.isHome = e.url === '/';
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  changeCurrency(item: Currency): void {
    this.currencyService.setCurrency(item.code || 'USD');
  }

  changeNetwork() {
    this.walletService.chooseNetwork()
  }

  toReferralPage() {
                                      //      how-it-works
    this.router.navigate(['/profile/referral/your-referrals']).then(() => {
      document.querySelector('.wrapper')?.scrollTo(0, 0);
    });
  }

  startAuth() { 
    if (!this.auth.isLoggedIn) {

      if(!Number(localStorage.getItem('isShowRefferal'))) {
        this.modalService.show(ReferalModalComponent,  {
          initialState: {
            onSuccess: () => {
              this.walletService.connectWallet()
            }
          },
          class: 'modal-defi',
        });
      } else {
        this.walletService.connectWallet()
      }
    }
  }

  logout() {
    this.walletService.disconnectWallet()
  }
}
